import React, { Component } from 'react';
import { navigate } from '@reach/router';
import { LocationProvider, Match } from '@reach/router';

import Layout from 'components/Layout/Layout';
import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import Order from 'components/Order/Order';
import FormStatus from 'components/FormStatus/FormStatus';
import CookieBanner from 'components/CookieBanner/CookieBanner';
import { classnames, classname, refEmail } from 'utils';
import { resolvePopup } from 'components/Popups/registry';

import './App.css';

export default class App extends Component {
  cl = classname('app');

  componentDidMount() {
    if (!process.browser) return;

    refEmail();

    this.event = (event) => this.onClick(event);
    document.body.addEventListener('click', this.event);

    document.documentElement.removeAttribute('data-loading');

    LocationProvider.defaultProps.history.listen(() => {
      setTimeout(() => this.goToHash());
    });

    this.goToHash();
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.event);
  }

  goToHash = () => {
    if (window.location.hash) {
      const anchor = document.querySelector(decodeURI(window.location.hash));

      if (anchor) {
        document.scrollingElement.scrollTop = anchor.offset().top;
      }
    }
  };

  onClick = (event) => {
    const link = event.target.closest('a');
    if (link && link.target !== '_self') {
      event.preventDefault();

      const href = link.getAttribute('href');
      const target = link.getAttribute('target');

      if (target === '_blank') {
        window.open(link.href);
      } else if (target === '_self') {
        navigate(href);
      } else {
        if (href && href[0] !== '#') {
          if (href[0] === '/') {
            navigate(href);
          } else {
            window.open(href);
          }
        }
      }
    }
  };

  render() {
    const { className, path, children, pageContext = {} } = this.props;

    const { header, category } = pageContext || {};
    const classes = classnames(this.cl('container'), className);
    const overlay = header && header.type ? ['main', 'light'].includes(header.type) : false;
    const url = this.props['*'];
    const logo = header && header.logo && header.logo;

    const getPathFromProps = () => {
      if (path) {
        return path.replace(/^\/+|\/+$/g, '');
      }
      return '';
    };
    const fallbackPath = getPathFromProps();

    return (
      <Match path={'*'}>
        {({ match }) => {
          const matchPath = match && match['*'] !== undefined ? match['*'] : fallbackPath;
          const isOrder = matchPath ? ['order', 'contacts', 'menu', '404', 'order-success'].includes(matchPath) : false;

          const budget = {
            strategy: null,
            brands: null,
            performance: null,
            media: null,
            dashboards: null,
            sites: 'small',
            services: 'small'
          };

          // const rawMatch = matchPath || fallbackPath;
          // const currentPath = `/${rawMatch}`;

          // const PopupComponent = resolvePopup(currentPath);

          // // Определяем, является ли это главной страницей
          // const isMain = header?.type === 'main' || path === '/' || !path || path === '';

          // // Для главной страницы устанавливаем theme='light'
          // const headerTheme = isMain ? 'light' : overlay ? 'light' : 'dark';

          return (
            <Layout>
              <div className={classes}>
                <Header
                  className={this.cl('header')}
                  theme={overlay ? 'light' : 'dark'}
                  path={path}
                  type={header ? header.type : null}
                  logo={logo}
                  headerColor={header?.headerColor}
                />
                <div className={this.cl('flow')}>{children}</div>
                {!isOrder &&
                  (category !== 'jobs' ? (
                    //   url in budget ? (
                    //     <Order budget={budget[url]} />
                    //   ) : (
                    <Order department={true} />
                  ) : (
                    // )
                    <Order title={'Отправить<br />резюме'} action={'jobs'} />
                  ))}

                <Footer className={this.cl('footer')} />

                {/* {PopupComponent ? <PopupComponent /> : null} */}
                <CookieBanner />
              </div>
            </Layout>
          );
        }}
      </Match>
    );
  }
}
